"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecordsById = void 0;
function getRecordsById(records = []) {
    const recordsById = {};
    records.forEach((record) => record?.id != null && (recordsById[record.id] = record));
    return recordsById;
}
exports.getRecordsById = getRecordsById;
